if ($(".l-floormap-unit").length){
  $('.-place').mouseover(function (e) {
    var num = $(this).children().data('num');
    $(this).parent().parent().addClass('is-select-' + num);
    $(this).parent().parent().addClass('is-current');
  });
  $('.-place').mouseout(function (e) {
    var num = $(this).children().data('num');
    $(this).parent().parent().removeClass('is-select-' + num);
    $(this).parent().parent().removeClass('is-current');
  });
  $('.l-floormap-unit-detail__link').mouseover(function (e) {
    var num = $(this).data('num');
    $(this).parent().parent().parent().parent().addClass('is-select-' + num);
    $(this).parent().parent().parent().parent().addClass('is-current');
  });
  $('.l-floormap-unit-detail__link').mouseout(function (e) {
    var num = $(this).data('num');
    $(this).parent().parent().parent().parent().removeClass('is-select-' + num);
    $(this).parent().parent().parent().parent().removeClass('is-current');
  });
}
